export class UserAuthRequestModel {
  public token: string;

  public state: string | null;

  public redirect_uri: string | null;
}
